
$(function() {
	// var disqus_config = function () {
	// 	this.page.identifier = article.id;
	// 	};
		
		// (function() { // DON'T EDIT BELOW THIS LINE
		// var d = document, s = d.createElement('script');
		// s.src = 'https://ghmagical.disqus.com/embed.js';
		// s.setAttribute('data-timestamp', +new Date());
		// (d.head || d.body).appendChild(s);
		// })();
	function markdownToCRenderer(toc) {
	    let html = "",
	      curLevel = 0;
	    for (let i = 0, len = toc.length; i < len; i++) {
	      const text = toc[i].text,
					level = toc[i].level,
					id = toc[i].id;

	      if (level > curLevel) {
	        // 上级
	        html += "";
	      } else if (level < curLevel) {
	        // 下级
	        html += new Array(curLevel - level + 2).join("</ul></li>");
	      } else {
	        // 同级
	        html += "</ul></li>";
	      }

	      html +=
	        '<li><a title="' + text + '" class="toc-level-' +
	        level +
	        '" href="#' +
	        id +
	        '" level="' +
	        level +
	        '">' +
	        text +
	        "</a><ul>";
	      curLevel = level;
	    }
	    html = `<ul class="md-toc-list">${html}</ul>`;
	    return html;
	  }

	const content = document.querySelector('.show-content');
	const headers = content.querySelectorAll('h1, h2, h3, h4, h5');
	const toc = [];
	for (let i = 0; i < headers.length; i++) {
		let tagName = headers[i].tagName;
		toc.push({
			text: headers[i].textContent,
			level: tagName.slice(1),
			id: headers[i].id
		});
	}
	if (toc && toc.length > 0) {
		document.querySelector('.article-toc').style.display = 'block';
		document.querySelector('.toc-list').innerHTML = markdownToCRenderer(toc);
	} else {
		document.querySelector('.article-toc').style.display = 'none';
	}
});